module.exports = __webpack_public_path__ + "files/f7f1b9361aacb4c3045ac05bfb8368b7.png";